import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { createRefOut } from '../../../common/api';
import { toast } from 'react-toastify';
import { formatDate } from '../../../common/utils';
import { Typeahead } from 'react-bootstrap-typeahead';

import '../modals.css';

const AddReferredOut = ( { close, aid, uid, cid, contacts, pType } ) => {
    const [ name, setName ] = useState( '' );
    const [ type, setType ] = useState( '' );
    const [ refDate, setRefDate ] = useState( '' );
    const [ refTo, setRefTo ] = useState( '' );
    const [ ready, setReady ] = useState( false );
    const [ processing, setProcessing ] = useState( false );
    const [ searchList, setSearchList ] = useState( [] );
    const [ singleSelections, setSingleSelections ] = useState( [] );
    const [ fn, setFN ] = useState( '' );

    useEffect( () => {
        if ( name.length > 0 && singleSelections.length > 0 ) {
            setRefTo( singleSelections[0].cid );
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ name, singleSelections ] );

    useEffect( () => {
        const c = contacts[cid];
        if ( c ) {
            setFN( c.firstname );
        }
    }, [ cid, contacts ] );

    useEffect( () => {
        const today = new Date();
        setRefDate( formatDate( today ) );
        setType( pType.find( p => p.default ).value );
    }, [ pType ] );

    const create = async () => {
        setProcessing( true );

        const ref = {
            name: name,
            refOutId: cid,
            refToId: refTo,
            refDate: refDate,
            refType: type
        };

        const added = await createRefOut( aid, uid, ref );
        if ( added.length ) {
            toast.success( `The Referral Out has been recorded`, { theme: 'dark' } );
            setProcessing( false );
            close();
        }
    }

    useEffect( () => {
        let list = [];
        if ( contacts ) {
            Object.keys( contacts ).forEach( cid => {
                const c = contacts[cid];

                if ( ( aid !== 'TeamHunter') || ( !c.loId && uid !== 'brandon.carroll@ccm.com' ) || c.loId === uid ) {
                    list.push( {
                        id: c.cid,
                        cid: c.cid,
                        firstname: c.firstname,
                        lastname: c.lastname,
                        name: c.name,
                        email: c.email,
                        email2: c.email2,
                        phone: c.phone,
                        phoneMobile: c.phoneMobile,
                        phoneWork: c.phoneWork,
                        firstnamePartner1: c.firstnamePartner1,
                        lastnamePartner1: c.lastnamePartner1,
                        emailPartner1: c.emailPartner1,
                        phonePartner1: c.phonePartner1,
                        firstnamePartner2: c.firstnamePartner2,
                        lastnamePartner2: c.lastnamePartner2,
                        emailPartner2: c.emailPartner2,
                        phonePartner2: c.phonePartner2,
                        team: c.team,
                        employer: c.employer,
                        priRole: c.priRole
                    } );
                }
            } );
        }
        setSearchList( list );
    }, [ contacts, aid, uid ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Refer {fn} to...</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Date of this referral</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="date" value={refDate} onChange={ ( e ) => setRefDate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Reason for this referral</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a reason" value={name} onChange={ ( e ) => setName( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Referring Partner</Form.Label>
                                        <Typeahead
                                            filterBy={ [ 'firstname', 'lastname', 'email', 'team', 'employer', 'name' ] }
                                            id="tf-refout-referral-finder"
                                            labelKey={ ( option ) => `${option.firstname} ${option.lastname}` }
                                            onChange={setSingleSelections}
                                            selected={singleSelections}
                                            options={ searchList }
                                            placeholder="Search Contacts..."
                                            renderMenuItemChildren={ ( option ) => (
                                                <div>
                                                    {option.firstname + ' ' + option.lastname}
                                                    <div>
                                                        <small>Email: {option.email}</small>
                                                    </div>
                                                </div>
                                            )}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Referral Partner's Business</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={type} onChange={ ( e ) => setType( e.target.value ) }>
                                            {
                                                pType.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    cid: state.contacts.currentId,
    contacts: state.contacts.byId,
    pType: state.user.meta.referredout.picklist.type
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( AddReferredOut );